/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import ViewDetails from "../common/viewDetails";
import OrderDetailsInvoice from "../shipmentComponent/orderDetailsInvoice.jsx";
import ReadAxios from "../axiosComponent/read";

const ModalOrderDetails = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
  modalOpen,
  handleClose,
  viewModeData,
}) => {
  const [modalData, setModalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState({});

  useEffect(() => {
    setModalData(viewModeData);
    setLoading(false);
  }, [viewModeData]);

  const handleSubmited = () => { };

  const columnDefsView = [
    {
      headerName: "Order No",
      field: "order_no",
    },
    {
      headerName: "Booking No",
      field: "booking_number",
    },
    {
      headerName: "Required On",
      field: "required_on",
    },
    {
      headerName: "Vehicle Type",
      field: "vehicle",
    },
    {
      headerName: "Source",
      field: "source",
    },
    {
      headerName: "Destination",
      field: "destination",
    },
    {
      headerName: "Transporter",
      field: "transporter",
    },
    {
      headerName: "Final Rate",
      field: "final_rate",
    },
    {
      headerName: "Weight",
      field: "weight",
    },
    {
      headerName: "Offered rate",
      field: "offered_rate",
    },
    {
      headerName: "Ordered Status",
      field: "order_status.allotment_text",
    },
    {
      headerName: "Trip status",
      field: "trip_status",
    },
    {
      headerName: "Orders",
      field: "view",
      cellRenderer: "ViewDetails",
      //width: 150,
      //suppressToolPanel: true,
    },
  ];

  let rowValue = []

  modalData && modalData.forEach((object, index) => {
    let temp = {}
    temp = object;
    let allotment_text = {allotment_text : "NA"}
    temp.order_no = object?.order_no || "NA"
    temp.required_on = object?.required_on || "NA"
    temp.vehicle = object?.vehicle || "NA"
    temp.source = object?.source || "NA"
    temp.destination = object?.destination || "NA"
    temp.transporter = object?.transporter || "NA"
    temp.final_rate = object?.final_rate || "NA"
    temp.weight = object?.weight || "NA"
    temp.offered_rate = object?.offered_rate || "NA"
    temp.order_status = object?.order_status?.allotment_text ? object.order_status : allotment_text
    temp.trip_status = object?.trip_status || "NA"
    rowValue[index] = temp
  })

  const [openViewDetails, setOpenViewDetails] = useState(false);

  const handleViewDetailClose = (data) => {
    setOpenViewDetails(false);
  };

  const getRowDetails = (data) => {
    let orderId = data.order_id;
    setOpenViewDetails(true);
    if (orderId) {
      ReadAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${orderId}`,
      }).then((res) => {
        setOrderData(res.data.order);
      });
    }
  };

  var frameworkcomponent = {
    ViewDetails: ViewDetails,
  };

  return (
    <div>
      <Modal open={modalOpen} onClose={handleClose} size="fullscreen">
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
          <h2 className="page-title">{"Orders"}</h2>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <div className="ag-theme-material agOver">
            <AgGridReact
              domLayout="autoHeight"
              frameworkComponents={frameworkcomponent}
              columnDefs={columnDefsView}
              loading={loading}
              rowData={rowValue}
              //rowData={modalData}
              getRowDetails={getRowDetails}
            ></AgGridReact>
            <OrderDetailsInvoice
              modalOpen={openViewDetails}
              handleClose={handleViewDetailClose}
              orderData={orderData}
            ></OrderDetailsInvoice>
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );
};
// TODO: validation
const FormikViewDetails = withFormik({
  validationSchema: yup.object({}),
  mapPropsToValues: (props) => {
    return {};
  },
  handleSubmit(values, { setSubmitting, props }) { },
})(ModalOrderDetails);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikViewDetails)
);
